import { Logo } from './Logo';

export class Carrier {
  carrierShortCode: string;
  id: number;
  logo: Logo;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
      this.logo = data.logo ? new Logo(data.logo) : null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/Carrier.ts